import { getFromLocalStorage } from "@app/dashboard/utils/manageLocalStorage";
import { LOCAL_STORAGE_KEYS } from "@app/dashboard/constants/local-storage-keys";
import { axiosPublic } from "@app/dashboard/tools/axios/axiosInstance";

export const checkUser = async (usernameOrPhone: string) => {

  const reqBody = {
    "username": usernameOrPhone,
  };

  return axiosPublic.post(`/dashboard/api/v1/forget-password/submit-phone/`, reqBody);
};

export const forgetPasswordSubmitPhone = async (phoneNumber: string) => {
  const signupPhoneToken = await getFromLocalStorage(LOCAL_STORAGE_KEYS.SIGNUP_BY_PHONE_TOKEN);

  const reqBody = {
    "phone_number": phoneNumber,
    "token": signupPhoneToken,
  };

  // return axiosPublic.post(`/api/auth/reset_pass/input_phone_number`, reqBody);
  return axiosPublic.post(`/dashboard/api/v1/forget-password/input_phone/`, reqBody);
};

export const forgetPasswordVerifyOtp = async (otp: string) => {
  const signupPhoneToken = await getFromLocalStorage(LOCAL_STORAGE_KEYS.SIGNUP_BY_PHONE_TOKEN);

  const reqBody = {
    "otp": otp,
    "token": signupPhoneToken,
  };

  return axiosPublic.post(`/dashboard/api/v1/forget-password/otp-verify/`, reqBody);
};

export const resetPassword = async (password: string) => {
  const signupPhoneToken = await getFromLocalStorage(LOCAL_STORAGE_KEYS.SIGNUP_BY_PHONE_TOKEN);

  const reqBody = {
    "password": password,
    "token": signupPhoneToken
  };

  return axiosPublic.post(`/dashboard/api/v1/forget-password/reset/`, reqBody);
};